import { useQuery } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_TABLES_AREAS_PATH } from '@/services'

export const useGetServiceBookingAreas = (tokenId, config = {}) => {
  const api = useLegacyPublicApi()

  return useQuery({
    queryKey: ['get-table-service-booking-areas', tokenId],
    queryFn: () =>
      api.get(SERVICE_BOOKING_TABLES_AREAS_PATH.replace('{tokenId}', tokenId)),
    select: (data) => data.data,
    ...config,
  })
}
